import Container from "../core/Container"
import Image from "../core/Image"
import Paragraph from "../core/Paragraph"
import SectionTag from "../core/SectionTag"

export default function AboutUs() {

    return(
        <Container bgColor="gray-50" className="w-full py-16 md:py-24">
            <Container bgColor="transparent" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                {/* Heading Section */}
                <SectionTag>O nás</SectionTag>

                {/* Content Grid */}
                <Container bgColor="white" radius="xl" shadow className="p-4 sm:p-6 md:p-8 lg:p-12 mt-6 sm:mt-8 grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center">
                    {/* Text Content */}
                    <Container bgColor="transparent" className="order-2 lg:order-1 space-y-4 sm:space-y-5">
                        <Container bgColor="transparent" className="mb-4 sm:mb-6">
                            <Paragraph variant="lead_black" className="text-base sm:text-lg md:text-xl leading-relaxed">
                                Pomáháme lidem zorientovat se v rychle se měnícím světě <span className="font-bold text-main">digitálních technologií</span> a efektivně je využívat v praxi.
                            </Paragraph>
                        </Container>
                        <Container bgColor="transparent" className="space-y-3 sm:space-y-4">
                            <Paragraph variant="lead_black" className="text-sm sm:text-base md:text-lg leading-relaxed">
                                Zaměřujeme se na vzdělávací akce v oblasti <span className="font-bold text-main">DIGI dovedností</span>, které jsou klíčové pro osobní rozvoj i pracovní uplatnění.
                            </Paragraph>
                            <Paragraph variant="lead_black" className="text-sm sm:text-base md:text-lg leading-relaxed">
                                Naší specializací jsou školení zaměřená na <span className="font-bold text-main">umělou inteligenci</span>, <span className="font-bold text-main">kancelářské balíčky</span>, <span className="font-bold text-main">algoritmizaci</span> a <span className="font-bold text-main">vzdělávací aplikace</span>. Přibližujeme <span className="font-bold text-main">moderní technologie</span> praktickou formou – bez zbytečné teorie, s důrazem na reálné využití.
                            </Paragraph>
                            <Paragraph variant="lead_black" className="text-sm sm:text-base md:text-lg leading-relaxed">
                                Spolupracujeme s jednotlivci, firmami i školami. Pomáháme rozvíjet <span className="font-bold text-main">digitální kompetence</span> a připravujeme vzdělávací programy reflektující aktuální trendy v <span className="font-bold text-main">digitálním vzdělávání</span>.
                            </Paragraph>
                        </Container>
                    </Container>

                    {/* Image Content */}
                    <Container bgColor="transparent" className="order-1 lg:order-2 flex justify-center items-center">
                        <div className="relative group w-full max-w-md lg:max-w-full">
                            <div className="relative transform transition-transform duration-300 hover:scale-105">
                                <Image
                                    src="./img/digiboy_bulb.png"
                                    alt="DigiBoy s žárovkou"
                                    width={500}
                                    className="w-full h-auto"
                                />
                            </div>
                        </div>
                    </Container>
                </Container>
            </Container>
        </Container>
    )
}